import { MimeType } from './constants';

export type AttachmentName = {
  mimeType: MimeType;
  name: string;
};

export enum RichTextEditorExtensions {
  AutoCloseVariableExtension,
}
